import { useAtomValue } from 'jotai';
import React from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';

import { LoadingContainer } from '../../components/LoadingContainer';
import { useConfig } from '../../hooks/use-config';
import { usePlayLearnMeeting } from '../../hooks/use-play-learn-meeting';
import { userAtom } from '../../jotai-atoms/user.atom';
import { ErrorPage } from '../Error/Error';
import { Play2LearnZoomFooter } from './Play2LearnZoomFooter';

export const Play2LearnZoomPage: React.FC = () => {
  const { data, isError, isFetching } = usePlayLearnMeeting();
  const { config } = useConfig();
  const user = useAtomValue(userAtom);
  const userLang = user?.lang ?? 'en';
  const zoomWebFile = 'junior-zoom-web-sdk-3-10-0.html';

  if (isError) {
    return <ErrorPage />;
  }

  return (
    <Container>
      {isFetching ? (
        <LoadingContainer />
      ) : (
        <Content>
          <ZoomIframe
            allow="camera; microphone; autoplay; screen-wake-lock"
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
            src={`${config.assetsBucket}/assets/${zoomWebFile}?lang=${userLang}&meetingNumber=${data?.meetingNumber}&username=${data?.userName}&link=${data?.meetingLink}&sdkKey=${data?.sdkKey}&signature=${data?.signature}`}
          />

          <StyledIframeContainer>
            <StyledIframe
              name="Kahoot"
              allow="autoplay"
              src={`${config.kahootUrl}?embed=true&lang=${userLang}`}
            />
          </StyledIframeContainer>
        </Content>
      )}

      {!isFetching && <Play2LearnZoomFooter serviceTeamUrl={data?.serviceTeamUrl} />}
    </Container>
  );
};

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundLight};
  min-height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 12px;
  gap: 12px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const StyledIframeContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: ${isMobile ? 320 : 400}px;
  min-height: ${isMobile ? 650 : 580}px;
  max-width: 400px;

  @media screen and (max-width: 768px) {
    max-width: none;
    width: auto;
  }
`;

const StyledIframe = styled.iframe`
  height: 100%;
  width: 100%;
  min-width: ${isMobile ? 320 : 400}px;
  min-height: ${isMobile ? 650 : 580}px;
  border-radius: 12px;
  box-shadow: rgb(0 96 204 / 40%) 0px 0px 24px;
  border: 1px solid ${({ theme }) => theme.colors.backgroundDark};
  background-color: ${({ theme }) => theme.colors.white};
`;

const ZoomIframe = styled.iframe`
  flex: 1;
  border-radius: 12px;
  border: none;

  @media screen and (max-width: 768px) {
    min-height: 450px;
  }
`;
